import React from "react";

export const SporeBullet = ({ size = 22, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
    data-testid="spore-bullet"
  >
    <circle cx="12" cy="12" r="5.5" fill="#3FBF3F" opacity="0.95" />
    <circle cx="6.5" cy="8.5" r="2" fill="#1E90FF" opacity="0.85" />
    <circle cx="17" cy="7.5" r="1.6" fill="#3FBF3F" opacity="0.85" />
    <circle cx="17.5" cy="17" r="2.2" fill="#1E90FF" opacity="0.8" />
    <circle cx="6" cy="17" r="1.7" fill="#3FBF3F" opacity="0.8" />
    <circle cx="12" cy="3.5" r="1.1" fill="#94A3B8" opacity="0.6" />
  </svg>
);

export default SporeBullet;
